import { Document } from "../document"

export interface AccountMetadata extends Document {
  email: string
}
